import {AppConfig} from '../AppConfig'

// Восстанавливаем порядок символов публичного ключа для защиты от автоматизации
// получения телефонных номеров из объявлений.
// Это маскировка от поиска по JS файлам.
export const onAppLoaded = () => {
    const fn: typeof atob = window[('at' + 'ob') as 'atob']
    if (!window[fn('YXBwTG9hZGVk') as 'appLoaded']) {
        const k1: keyof typeof AppConfig = fn('bGFyYXZlbEVjaG8=') as 'laravelEcho'
        const k2 = fn('dG9rZW4=') as 'token'
        // Берем публичный ключ из AppConfig.laravelEcho.token,
        // восстанавливаем порядок символов и декодируем из base64.
        const bin: string = fn(
            // @ts-ignore AppConfig.laravelEcho.token
            (AppConfig[k1][k2] as string).split('').reverse().join('')
        )
        // Преобразуем получившееся значение в Uint8Array.
        const bArr: Uint8Array = new window[fn('VWludDhBcnJheQ==') as 'Uint8Array'](bin.length)
        for (let i: number = 0; i < bin.length; i++) {
            bArr[i] = bin[fn('Y2hhckNvZGVBdA==') as 'charCodeAt'](i)
        }
        // Сохраняем bytes.buffer в AppConfig, чтобы еще больше запутать.
        // @ts-ignore
        AppConfig[k1][k2] = bArr[fn('YnVmZmVy') as 'buffer']
    }
}
